import actions from './actions'

export default function DevicesReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_DEVICE:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.FILTER_DEVICES_RECIEVED:
      return {
        ...state,
        lists: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_DEVICE:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_DEVICE:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_DEVICE:
      return {
        ...state,
        editing: { deviceID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_DEVICE_RECIEVED ||
      actions.UPDATE_DEVICE_RECIEVED ||
      actions.DELETE_DEVICE_RECIEVED:
      return {
        ...state,
        editing: { deviceID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
